import { z } from "zod";

export type CommercialSubmissionParty = {
  clientName?: unknown;
  contactName?: unknown;
  phone?: unknown;
  email?: unknown;
  contactMethod?: unknown;
};

export function hasCommercialSubmissionIdentity(input: {
  customerPartnerId?: unknown;
  parties: CommercialSubmissionParty;
}): boolean {
  const partnerId = Number(input.customerPartnerId);
  const hasLinkedCustomer = Number.isSafeInteger(partnerId) && partnerId > 0;
  const hasNamedClient = String(input.parties.clientName ?? "").trim().length > 0;
  const hasNamedContact = String(input.parties.contactName ?? "").trim().length > 0;
  return hasLinkedCustomer || hasNamedClient || hasNamedContact;
}

export function isValidCommercialPhone(value: unknown): boolean {
  const phone = String(value ?? "").trim();
  const digits = phone.replace(/\D/g, "");
  return Boolean(
    phone &&
      phone.length <= 40 &&
      /^\+?[0-9().\s-]+$/.test(phone) &&
      digits.length >= 7 &&
      digits.length <= 15
  );
}

export function isValidCommercialEmail(value: unknown): boolean {
  return z.string().trim().email().max(255).safeParse(value).success;
}

export function hasCommercialSubmissionContactDetails(
  parties: CommercialSubmissionParty
): boolean {
  return isValidCommercialPhone(parties.phone) && isValidCommercialEmail(parties.email);
}

/** Compatibility rule for requests already sent to a customer before the two-channel requirement. */
export function hasCommercialSubmissionContactMethod(
  parties: CommercialSubmissionParty
): boolean {
  const contactMethod = String(parties.contactMethod ?? "").trim();
  return (
    isValidCommercialPhone(parties.phone) ||
    isValidCommercialEmail(parties.email) ||
    (contactMethod.includes("@")
      ? isValidCommercialEmail(contactMethod)
      : isValidCommercialPhone(contactMethod))
  );
}
